<template>
    <router-view name="secondaryTitle"></router-view>
</template>

<script>
export default {
    name: "BlankSecondaryTitle"
}
</script>